import type { ConceptDef } from '../types';

export const echoicSyllables: ConceptDef = {
  kind: 'supervisorScored',
  id: 'echoic-syllables',
  label: 'Echoic Syllables',
  category: 'Echoic',
  description: 'Speak a syllable; learner repeats it. Supervisor scores.',
  config: {
    promptMode: 'AUDIO',
    prompts: [
      { prompt: 'ba' },
      { prompt: 'da' },
      { prompt: 'ga' },
      { prompt: 'ma' },
      { prompt: 'pa' },
      { prompt: 'na' },
      { prompt: 'la' },
      { prompt: 'ka' },
    ],
  },
};
